import { memo, useCallback } from 'react';

import { CirclePlayIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { useResumeImportMutation } from '~/swr-hooks/importer/useResumeImportMutation';

export type WorkspaceImportsResumeAllButtonProps = {
  stoppedImportIds: string[];
};

export const WorkspaceImportsResumeAllButton = memo(({ stoppedImportIds }: WorkspaceImportsResumeAllButtonProps) => {
  const { mutation: resumeImportMutation } = useResumeImportMutation();

  const handleResumeAll = useCallback(() => {
    resumeImportMutation.mutate(stoppedImportIds);
  }, [resumeImportMutation, stoppedImportIds]);

  return (
    <Button
      appearance="ghost"
      className="ads:text-primary text-gray-12"
      color="gray"
      data-testid="WORKSPACE_IMPORTS_RESUME_ALL_BUTTON"
      isLoading={resumeImportMutation.isPending}
      onClick={handleResumeAll}
      prefix={<CirclePlayIcon aria-hidden size="xs" />}
      size="small"
      type="button"
    >
      Resume all
    </Button>
  );
});

WorkspaceImportsResumeAllButton.displayName = 'WorkspaceImportsResumeAllButton';
